$(document).ready(function() {
    $('.parallax-window').parallax();
    $(window).resize(function() {

        $('.parallax-window').parallax();

    });
});